<template>
  <div>
    <v-card elevation="4" color="#f7f7fc" class="auth-card">
      <v-card-text>
        <v-container>
          <form @submit.prevent="onSignin">
            <h1 v-if="fromPage" class="secondary--text text-center">
              Sign In to your Strapp Account
            </h1>
            <h1 v-else-if="addItem" class="secondary--text text-center">
              Login to complete your listing!
            </h1>
            <h1 v-else-if="addBooking" class="secondary--text text-center">
              Login to complete your booking!
            </h1>
            <div class="my-7 mx-md-12">
              <center>
                <v-btn
                  @click="signInWithGoogle"
                  class="mb-2 text-caption text-md-body-2"
                  elevation="2"
                  color="#34A853"
                  style="border-radius: 8px"
                  outlined
                  block
                  rounded
                  ><img
                    class="mr-2"
                    src="https://img.icons8.com/color/28/000000/google-logo.png"
                  />
                  &nbsp; Google Sign In</v-btn
                >
                <!-- <v-btn
                  @click="signInWithFacebook"
                  elevation="2"
                  class="mb-2"
                  color="#039BE5"
                  style="border-radius: 8px;"
                  outlined
                  rounded
                  block
                  ><img
                    class="mr-2"
                    src="https://img.icons8.com/color/28/000000/facebook-new.png"
                  />
                  &nbsp; Facebook Sign In</v-btn
                > -->
              </center>
            </div>

            <div class="d-flex my-3">
              <v-divider class="my-1"></v-divider>
              <div class="text-overline mx-1 mt-n3">Or Sign In With</div>
              <v-divider class="my-1"></v-divider>
            </div>

            <v-text-field
              id="email"
              outlined
              style="border-radius: 8px"
              v-model="email"
              name="email"
              label="Mail"
              type="email"
              required
            />

            <v-text-field
              block
              id="password"
              outlined
              style="border-radius: 8px"
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="password"
              label="Password"
              required
              @click:append="show = !show"
            />

            <v-row v-if="error">
              <!-- <v-col cols="12" sm="6" offset-sm="3"> -->
              <!-- <app-alert
                class="mx-8"
                block
                @dismissed="onDismissed"
              /> -->

              <app-alert
                class="ma-6"
                block
                :text="error"
                @dismissed="onDismissed"
              ></app-alert>
              <!-- </v-col> -->
            </v-row>
            <!-- <v-col cols="12">
                      <v-text-field
                        id="confirmPassword"
                        v-model="confirmPassword"
                        name="confirmPassword"
                        label="Confirm Password"
                        type="password"
                        :rules="[comparePasswords]"
                      />
                    </v-col> -->

            <v-row>
              <v-col cols="12">
                <div v-if="fromPage">
                  Don't have an account ?
                  <div
                    style="cursor: pointer"
                    class="font-weight-bold d-inline-block accent--text"
                    @click="$emit('changeDialog')"
                  >
                    Sign up
                  </div>
                </div>
                <div v-else>
                  Don't have an account ?
                  <div
                    style="cursor: pointer"
                    class="font-weight-bold d-inline-block accent--text"
                    @click="$emit('changeDialog')"
                  >
                    Sign up
                  </div>
                  <span v-if="addItem"> to complete your listing</span>
                  <span v-else-if="addBooking"> to complete your booking</span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  rel="noopener"
                  target="_blank"
                  color="accent"
                  class="mb-3 sign-button"
                  block
                  large
                  :loading="loading"
                  style="
                    background-image: linear-gradient(
                      to right,
                      #a18cd1 0%,
                      #b22af0 100%
                    );
                    border-radius: 10px;
                  "
                  :disabled="!formIsValid || loading"
                >
                  Sign In
                </v-btn>

                <v-btn
                  style="
                    background-image: linear-gradient(
                      120deg,
                      #9fc746 0%,
                      #96e6a1 100%
                    );
                    border-radius: 10px;
                  "
                  outlined
                  color="accent"
                  @click="dialog = true"
                >
                  Forgot Password
                </v-btn>
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog
      style="border-radius: 12px !important"
      v-model="welcomeDialog"
      width="500"
    >
      <v-card style="border-radius: 12px !important" class="text-center">
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="welcomeDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Login Success</p>
        </v-card-title>
        <v-divider></v-divider>

        <base-img
          :src="require('@/assets/logos/icon1.svg')"
          class="mb-5 mt-15 mx-auto"
          contain
          height="100"
          width="382"
        />

        <p class="heading ml-auto mr-auto">Welcome Back!</p>
        <!-- <v-card-text
          style="    font-size: 16px !important;
    line-height: 20px !important;
    color: rgb(34, 34, 34) !important;"
        >
          Experience new ways of participating with your community
        </v-card-text> -->
        <!-- <v-card-text>
          Users will not be able to see your photo until a booking has been
          made.
        </v-card-text> -->

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-btn
            v-if="addItem"
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="welcomeDialog = false"
            color="black"
            :disabled="loading || formIsValid"
          >
            Finish Submitting Item
          </v-btn>

          <v-btn
            v-else
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="(verifyDialog = true), (startDialog = false)"
            color="black"
            :disabled="loading || formIsValid"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="568px" persistent>
      <v-card class="auth-card" max-width="568px">
        <v-card-title class="text-center black--text">
          <v-col cols="12">
            <v-row>
              <v-icon small color="black" @click="dialog = false"
                >mdi-close</v-icon
              >
              <p class="my-3 ml-auto mr-auto text-h6 font-weght-bold">
                Forgot Password?
              </p>
            </v-row>

            <v-row>
              <p class="ml-auto mr-auto text-body-2 font-weight-light">
                No worries, we will send you reset instructions
              </p>
            </v-row>
          </v-col>
          <v-divider></v-divider>
        </v-card-title>
        <v-row class="grid mt-2">
          <v-col cols="10">
            <v-text-field
              v-model="User.email"
              class="mx-2"
              type="email"
              label="Email"
              required
              outlined
              style="border-radius: 12px"
            />
          </v-col>
        </v-row>

        <v-row class="grid mt-n5">
          <v-col cols="8">
            <v-alert
              v-if="errorMessage !== ''"
              class="alert alert-warning round"
              type="error"
              outlined
            >
              {{ this.errorMessage }}
            </v-alert></v-col
          >
        </v-row>

        <v-card-actions class="grid">
          <v-col cols="10">
            <v-row>
              <v-btn
                block
                large
                class="btn white--text"
                style="border-radius: 12px !important"
                @click="forgotPassword()"
                color="accent"
              >
                Reset Password
              </v-btn>
            </v-row>
            <v-row class="mt-6">
              <v-btn
                block
                large
                class="btn white--text"
                style="border-radius: 12px !important"
                @click="dialog = false"
                color="accent"
                outlined
              >
                <v-icon class="mr-2">mdi-arrow-left</v-icon> Back to login
              </v-btn>
            </v-row>

            <p class="mt-9">
              Don't have an account?
              <span
                style="cursor: pointer"
                class="font-weight-bold"
                @click="toSignUp()"
              >
                Sign Up</span
              >
            </p>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Forgot Password Success  -->

    <v-dialog
      v-model="forgotPasswordSucccessDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1em !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <v-icon
              small
              color="black"
              @click="forgotPasswordSucccessDialog = false"
              >mdi-close</v-icon
            >
            <p class="my-3 ml-auto mr-auto">Email sent!</p>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-3">
            We have sent you an email with instructions on how to reset your
            password. 🎉 <br />
            Please check your inbox
          </v-card-text>

          <v-card-actions class="mt-n3">
            <v-btn
              block
              class="btn white--text"
              style="border-radius: 8px !important"
              @click="forgotPasswordSucccessDialog = false"
              color="accent"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import { firebaseAuth } from "../../main.js";

// import { config } from './../../helpers/firebaseConfig'
export default {
  name: "LoginComp",
  props: {
    shouldRedirect: {
      type: Boolean,
      default: true,
    },
    addItem: {
      type: Boolean,
      default: true,
    },
    addBooking: {
      type: Boolean,
      default: true,
    },
    fromPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      forgotPasswordSucccessDialog: false,
      dialog: false,
      color: "white",
      welcomeDialog: false,
      show: false,
      User: {
        email: "",
      },
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    formIsValid() {
      return this.email !== "" && this.password.length >= 8;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    user(value) {
      console.log("here?????", value);
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          console.log("we out here?????");

          this.$router.push("/dashboard");
          this.$emit("loggedIn");
        } else if (this.addItem) {
          this.$emit("loggedIn");
        } else {
          this.$emit("loggedIn");
        }
      }
    },
  },

  mounted() {
    this.$store.commit("setLoading", false);
    this.$store.dispatch("clearError");
  },
  methods: {
    toSignUp() {
      this.dialog = false;
      this.$emit("changeDialog");
    },
    onSignin() {
      this.$store.dispatch("signUserIn", {
        email: this.email,
        password: this.password,
      });
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },

    forgotPassword() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.User.email)
        .then(() => {
          this.forgotPasswordSucccessDialog = true;
          this.dialog = false;
          this.User = {
            email: "",
          };
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage =
            "We can't seem to find that email address. Please try again.";
        });
    },

    // async signIn() {
    //   try {
    //     await firebaseAuth.signInWithEmailAndPassword(
    //       this.email,
    //       this.password
    //     );
    //   } catch (error) {
    //     console.log(error);
    //     const errorCode = error.code;

    //     console.log('errorCode, errorMessage', errorCode, errorMessage);

    //     const errorMessage = error.message;
    //     if (errorCode === 'auth/wrong-password') {
    //       alert('Wrong Password');
    //     } else {
    //       alert(errorMessage);
    //     }
    //   }
    // },

    signInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        // .catch((error) => alert("🤕" + error.message))
        .then((data) => {
          console.log(data.user, data.credential.accessToken);
          const user = data.user;
          //check firesbase to see if user exists
          console.log("uid", user.uid);

          // if (firebase.firestore().collection('users').doc(user.uid) === null) {

          const userRef = firebase
            .firestore()
            .collection("users")
            .doc(user.uid);
          userRef.get().then((doc) => {
            if (!doc.exists) {
              firebase
                .firestore()
                .collection("users")
                .doc(user.uid)
                .set({
                  id: user.uid,
                  // email: user.email,
                  // username: user.email,
                  firstName: user.displayName.split(" ").slice(0, -1).join(" "),
                  createdAt: new Date(),
                  avatar: user.photoURL,
                })
                .then(
                  firebase
                    .firestore()
                    .collection("users")
                    .doc(user.uid)
                    .collection("privateData")
                    .doc(user.uid)
                    .set({
                      termsAndPrivacyPolicy: "true",
                      firstName: user.displayName
                        .split(" ")
                        .slice(0, -1)
                        .join(" "),
                      lastName: user.displayName.split(" ").slice(-1).join(" "),
                      createdAt: new Date(),
                      name: user.displayName,
                      email: user.email,
                    })
                )
                .then(
                  firebase
                    .firestore()
                    .collection("crmData")
                    .doc(user.uid)
                    .set({
                      id: user.uid,
                      email: user.email,
                      username: user.email,
                      createdAt: new Date(),
                      firstName: user.displayName
                        .split(" ")
                        .slice(0, -1)
                        .join(" "),
                      avatar: user.photoURL,
                    })
                )

                .then(() => dispatch("fetchAuthUser"));
              console.log("g sign up");
            } else {
              console.log("Document data:", doc.data());
              // dispatch('setUser', doc.data());
            }
          });

          // firebase
          //   .firestore()
          //   .collection('users')
          //   .doc(user.uid)
          //   .set({
          //     id: user.uid,
          //     // email: user.email,
          //     // username: user.email,
          //     firstName: user.displayName.split(' ').slice(0, -1).join(' '),
          //     createdAt: new Date(),
          //     avatar: user.photoURL,
          //   })
          //   .then(
          //     firebase
          //       .firestore()
          //       .collection('users')
          //       .doc(user.uid)
          //       .collection('privateData')
          //       .doc(user.uid)
          //       .set({
          //         termsAndPrivacyPolicy: 'true',
          //         firstName: user.displayName.split(' ').slice(0, -1).join(' '),
          //         lastName: user.displayName.split(' ').slice(-1).join(' '),
          //         createdAt: new Date(),
          //         name: user.displayName,
          //         email: user.email,
          //       })
          //   )
          //   .then(
          //     firebase
          //       .firestore()
          //       .collection('crmData')
          //       .doc(user.uid)
          //       .set({
          //         id: user.uid,
          //         email: user.email,
          //         username: user.email,
          //         createdAt: new Date(),
          //         firstName: user.displayName.split(' ').slice(0, -1).join(' '),
          //         avatar: user.photoURL,
          //       })
          //   )

          //   .then(() => dispatch('fetchAuthUser'));
          // console.log('g sign up');
          // }
        });
    },

    // signInWithFacebook() {
    //   var provider = new firebase.auth.FacebookAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .catch((error) => alert('🤕' + error.message))
    //     .then((data) => console.log(data.user, data.credential.accessToken))
    //     .then();
    // },

    onSignup() {
      this.$store.dispatch("signUserUp", {
        email: this.email,
        password: this.password,
      });
    },
  },
};
</script>

<style>
/* .centered {
  position: fixed;
  top: 22%;
  left: 50%;

  transform: translate(-50%, -50%);
} */
/* .below {
  position: fixed;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
} */

.round {
  border-radius: 16px !important;
}

.auth-card {
  width: 100% !important;
  max-width: 568px !important;
  border-radius: 18px !important;
}

.abutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.abutton:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}
</style>
